var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconosAmcTransito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.88,
    cy: 287.88,
    r: 287.88,
    fill: "none"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_998_618",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 150,
    width: 298,
    height: 278
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.755 256.136C202.52 242.643 210.257 229.954 221.151 219.123C259.835 180.439 322.534 180.439 361.218 219.123L371.802 229.769H350.572C339.617 229.769 330.766 238.62 330.766 249.575C330.766 260.53 339.617 269.381 350.572 269.381H419.585H419.832C430.788 269.381 439.639 260.53 439.639 249.575V180.253C439.639 169.298 430.788 160.447 419.832 160.447C408.877 160.447 400.026 169.298 400.026 180.253V202.04L389.194 191.146C335.037 136.989 247.27 136.989 193.112 191.146C178.01 206.249 167.117 224.012 160.432 243.014C156.78 253.35 162.227 264.615 172.502 268.267C182.776 271.919 194.103 266.472 197.755 256.198V256.136ZM156.842 309.798C153.747 310.727 150.777 312.398 148.363 314.874C145.887 317.349 144.216 320.32 143.349 323.539C143.163 324.282 142.978 325.086 142.854 325.891C142.668 326.943 142.606 327.995 142.606 329.047V398.122C142.606 409.077 151.457 417.928 162.413 417.928C173.368 417.928 182.219 409.077 182.219 398.122V376.397L193.112 387.228C247.27 441.324 335.037 441.324 389.133 387.228C404.235 372.126 415.19 354.362 421.875 335.423C425.527 325.086 420.08 313.821 409.805 310.17C399.531 306.518 388.204 311.965 384.552 322.239C379.786 335.732 372.05 348.421 361.156 359.252C322.472 397.936 259.773 397.936 221.089 359.252L221.027 359.19L210.443 348.606H231.735C242.69 348.606 251.541 339.755 251.541 328.8C251.541 317.845 242.69 308.994 231.735 308.994H162.66C161.67 308.994 160.68 309.056 159.689 309.179C158.699 309.303 157.771 309.489 156.842 309.798Z",
    fill: "#DCCCC9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_998_618)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -332.744,
    y: -182.218,
    width: 1101.23,
    height: 1045.77,
    fill: "#FA0073"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconosAmcTransito);
export default __webpack_public_path__ + "static/media/Iconos AMC_Transito.75e641d0b608025cdae31c4190a571f4.svg";
export { ForwardRef as ReactComponent };